import { Header } from "components/Header";
import { ReactNode } from "react";
import * as S from "./styles";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <S.Container>
      <Header />

      {children}
    </S.Container>
  );
}
